module.exports = __webpack_public_path__ + "static/img/wild.4e914fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/wild.png
// module id = YQAm
// module chunks = 0